import './bootstrap';
import {
    addBackToTop
} from 'vanilla-back-to-top';
import 'jquery-validation';
import 'owl.carousel2';
import 'bootstrap-select';
import 'tempusdominus-bootstrap-4';
import './jquery-ui.min';
import './jquery.ui.touch-punch.min';
import './slider';
import swal from 'sweetalert2';


var Page = function () {


    var initCaptcha = function () {
        $( '.slider_filled' ).sliderCaptcha({
            type: 'filled',
            hintText: 'Húzza el a gombot!',
            hintTextAfterUnlock: 'Most már letöltheti a dokumentumot',
            events: {
                validateOnServer: 1,
                validateOnServerParamName: "validateSliderCaptcha"
            }
        });        
    }

    var initNavbar = function () {

        $('[data-toggle="offcanvas"]').on('click', function () {
            $('.offcanvas-collapse').toggleClass('open');
            $('header').toggleClass('shrink-important');
        });

        $('#nav-icon3').click(function () {
            $(this).toggleClass('open');
        });

        if ($(window).width() > 768) {


            $('.nav-link').click(function () {
                if ($(this).attr('target') !== '_blank') {
                    window.location = $(this).attr('href');
                }
            });
            // when you hover a toggle show its dropdown menu
            $(".navbar .dropdown-large .dropdown-toggle").hover(function () {


                $(this).parent().toggleClass("show");

                var actualDropdown = $(this).parent().find(".dropdown-menu");

                actualDropdown.removeClass('d-none');

                var activeDropdown = $(".navbar .dropdown-menu.active-dropdown");

                actualDropdown.toggleClass("show");

                if (activeDropdown.data('id') !== actualDropdown.data('id')) {
                    activeDropdown.addClass("d-none");
                }else{
                    activeDropdown.removeClass("d-none");

                }

            });

            $(".navbar").mouseleave(function () {
                var activeDropdown = $(".navbar .dropdown-menu.active-dropdown");

                activeDropdown.removeClass('d-none');
            });

            var dropdownMenu = $('.navbar .dropdown-large').find('.active-dropdown');


            if (dropdownMenu.length) {
                $(".projects").toggleClass("d-none");
            } else {
                $('.navbar .dropdown-large').hover(function () {
                    $(".projects").toggleClass("d-none");
                });
            }

            // hide the menu when the mouse leaves the dropdown
            $(".navbar .dropdown-large .dropdown-menu").mouseleave(function () {
                $(this).removeClass("show");
            });
        }

        $('a.dropbtn').click(function (event) {
            if ($( document ).width() <= 1024) {
                event.preventDefault();
            }
        });

        if ($(window).width() < 769) {
            if ($('.navbar .submenu-active').length > 0) {
                var item = $('.navbar .submenu-active').first();
                item.closest('.active-dropdown').addClass('show');
                item.closest('.dropdown-large').addClass('show');
            }
        }

        var prevScrollpos = window.pageYOffset;

        window.onscroll = function () {
            var currentScrollPos = window.pageYOffset;
            if (prevScrollpos > currentScrollPos) {
                $('header').removeClass('shrink');
            } else {
                $('header').addClass('shrink');
            }
            prevScrollpos = currentScrollPos;
        };


    };

    var initBackToTop = function () {
        addBackToTop({
            diameter: 40,
            textColor: '#fff'
        });
    };

    var initPasswordShowHide = function () {
        $(".show_hide_password span").click(function (event) {
            event.preventDefault();
            if ($(this).closest('.show_hide_password').find('input').attr("type") == "text") {
                $(this).closest('.show_hide_password').find('input').attr('type', 'password');
                $(this).find('i').addClass("zmdi-eye-off");
                $(this).find('i').removeClass("zmdi-eye");
            } else if ($(this).closest('.show_hide_password').find('input').attr("type") == "password") {
                $(this).closest('.show_hide_password').find('input').attr('type', 'text');
                $(this).find('i').addClass("zmdi-eye");
                $(this).find('i').removeClass("zmdi-eye-off");
            }
        });
    };


    var initResponsiveTables = function () {
        $('.js-responsive-table').each(function () {

            var trAcc = $(this).find('tr');
            var thHead = [];

            $(this).find('tr td, tr th').each(function () {
                var headLines = $(this).text();
                thHead.push(headLines);
            });

            trAcc.each(function () {
                for (var i = 0, l = thHead.length; i < l; i++) {
                    $(this).find('td').eq(i).attr('data-label', thHead[i]);
                }
            });
        });
    };

    var initDownloadForm = function () {
        $('form.download').each(function () { // attach to all form elements on page
            $(this).submit(function (e) {
                e.preventDefault();
            }).validate({
                errorElement: 'div', //default input error message container
                errorClass: 'invalid-feedback animated fadeInDown', // default input error message class
                focusInvalid: true, // do not focus the last invalid input
                ignore: "",
                rules: {
                    email: {
                        required: true,
                        email: true,
                        maxlength: 255
                    },


                },
                messages: {
                    email: {
                        required: "A email cím megadása kötelező!",
                        email: "Az email cím helytelen!",
                        maxlength: "Legfeljebb {0} karakter hosszú legyen."
                    },

                },
                highlight: function (element) { // hightlight error inputs
                    $(element).closest('.form-group').addClass('is-invalid'); // set error class to the control group
                    $(element).addClass('is-invalid');
                    $(element).removeClass('is-valid');

                },

                unhighlight: function (element) { // hightlight error inputs
                    $(element).closest('.form-group').removeClass('is-invalid'); // set error class to the control group
                    $(element).removeClass('is-invalid');
                    $(element).addClass('is-valid');

                },

                submitHandler: function (form) {
                    var type = $(form).data('type');

                    if (type === 'download') {
                        downloadDocument(form);
                    }
                    if (type === 'send-email') {
                        sendDocument(form);
                    }
                }
            });
        });


    };


    var sendDocument = function (form) {

        var form = $(form);
        form.closest('.card-body').addClass('loading');
        var fileName = form.data('file');
        var email = form.find('.email').val();
        var documentId = form.find('button').data('id');
        var captcha = form.find('.g-recaptcha-response').val();

        var data = {
            document_id: documentId,
            "g-recaptcha-response": captcha,
            email: email
        };

        axios({
            url: '/ajax/document/send',
            data: data,
            method: 'POST',
            responseType: 'json', // important
        }).then((response) => {

            form.closest('.card-body').removeClass('loading');

            swal(
                'Rendben!',
                response.data.msg,
                'success'
            );
            form.closest('.collapse').collapse('hide');
        }).catch(function (error) {

            form.closest('.card-body').removeClass('loading');

            showError(error);
        });
    };

    var getErrorsList = function (error) {

        var errors = [];

        for (var propertyName in error.response.data.errors) {

            var messages = error.response.data.errors[propertyName];

            for (var msg in messages) {
                errors.push({
                    'msg': messages[msg]
                });
            }
        }

        const markup = `
            <ol class="quotes">
                ${errors.map(error => `<li>${error.msg} </li>`).join('')}
            </ol>`;

        return markup;
    }

    var downloadDocument = function (form) {

        var form = $(form);
        form.closest('.card-body').addClass('loading');

        var fileName = form.data('file');
        var documentId = form.find('button').data('id');
        var captcha = form.find('.g-recaptcha-response').val();

        var data = {
            document_id: documentId,
            "g-recaptcha-response": captcha
        };

        axios({
            url: '/ajax/document/download',
            data: data,
            method: 'POST',
            responseType: 'blob', // important
        }).then((response) => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); //or any other extension
            document.body.appendChild(link);
            link.click();
            form.closest('.card-body').removeClass('loading');
            form.closest('.collapse').collapse('hide');


        }).catch(function (error) {
            showError(error);
            form.closest('.card-body').removeClass('loading');

        });
    };

    var showError = function (error) {
        swal({
            html: getErrorsList(error),
            title: "Hiba!",
            showCloseButton: true,
            showCancelButton: false,
            buttonsStyling: false,
            type: "error",
            animation: true,
            customClass: "error",
            focusConfirm: false,
            confirmButtonClass: 'btn btn-nmfr',
            confirmButtonText: 'Rendben',
        });
    }


    var initBootstrapComponents = function () {
        $('[data-toggle="tooltip"]').tooltip();
        $('[data-toggle="popover"]').popover();
    };


    var initBlindModeSwitcher = function () {

        $('.blindMode').click(function () {
            axios.post('/ajax/setBlindMode')
                .then(function (response) {
                    $('#page-style').attr('href', response.data.style);
                    if (response.data.blind_mode) {
                        localStorage.setItem('generatedStyles', $('#generated-styles').html());
                        $('#generated-styles').empty();
                    } else {
                        $('#generated-styles').append(localStorage.getItem('generatedStyles'));
                    }
                });
        });
    };

    var initOwlCarousel = function () {
        $('.owl-carousel').owlCarousel({
            loop: true,
            margin: 10,
            responsiveClass: true,
            autoplay: false,
            autoplayTimeout: 2000,
            autoplayHoverPause: true,
            navText: ["<i class='zmdi zmdi-caret-left-circle'></i>","<i class='zmdi zmdi-caret-right-circle'></i>"],
            responsive: {
                0: {
                    items: 3,
                    nav: true,
                    loop: true
                },
                600: {
                    items: 6,
                    nav: true,
                    loop: true
                },
                1000: {
                    items: 10,
                    nav: true,
                    loop: true
                }
            }
        });
    };



    var initDatePicker = function () {

        var dtpOptions = {

            icons: {
                time: 'zmdi zmdi-time zmdi-hc-fw',
                date: 'zmdi zmdi-calendar zmdi-hc-fw',
                up: 'zmdi zmdi-long-arrow-up zmdi-hc-fw',
                down: 'zmdi zmdi-long-arrow-down zmdi-hc-fw',
                previous: 'zmdi zmdi-long-arrow-left zmdi-hc-fw',
                next: 'zmdi zmdi-long-arrow-right zmdi-hc-fw',
                today: 'zmdi zmdi-calendar-check zmdi-hc-fw',
                clear: 'zmdi zmdi-delete zmdi-hc-fw',
                close: 'zmdi zmdi-calendar-close zmdi-hc-fw'
            },
            pickTime: true,
            language: 'hu',
            use24hours: true,
            minDate: '2014-07-01 00:00:00',
            orientation: 'top right',
            beforeShow:  function() {
                setTimeout(function() {
                    $("#ui-datepicker-div").css("z-index", 1000000);
                }, 10);
            }
        };

        $('.date-time-picker').datetimepicker(dtpOptions);
    };

    var initSelect = function () {
        $('.selectpicker').selectpicker();
    };    



    return {
        //main function to initiate the module
        init: function () {
            initNavbar();
            initBackToTop();
            initOwlCarousel();
            initDownloadForm();
            initPasswordShowHide();
            initResponsiveTables();
            initBootstrapComponents();
            initBlindModeSwitcher();
            initCaptcha();
            initDatePicker();
            initSelect();
        }
    };
}();

$(document).ready(function () {
    window.Page = Page;
    window.Page.init();

});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js